<template>
  <CContainer>
    <h3>Datos Oportunidad</h3>
    <CCard class="mt-4">
      <CCardBody>
        <CForm class="p-2">
          <CRow>
            <CCol col="12" sm="12">
              <CAutocomplete
                required
                label="Directorio:"
                :options="directories"
                :value.sync="opportunity.directory"
                @update-search="value => getDirectoryData(value)"
                @update:input="(newValue) => {
                  opportunity.directory = newValue
                  newValue ? getDependencies() : null
                }">
              </CAutocomplete>
            </CCol>
            <CCol col="12" sm="6">
              <CAutocomplete
                label="Dependencia / CenCos: "
                :options="dependencies"
                :value.sync="opportunity.dependency"
                @update:input="(newValue) => {
                  opportunity.dependency = newValue
                }">
              </CAutocomplete>
            </CCol>
            <CCol sm="6">
              <CAutocomplete
                label="Campaña: "
                :options="campaigns"
                :value.sync="opportunity.campaign"
                @update:input="(newValue) => {
                  opportunity.campaign = newValue
                }">
              </CAutocomplete>
            </CCol>
            <CCol sm="6">
              <CAutocomplete
                required
                label="Origen Oportunidad: "
                :options="opportunityOrigins"
                :value.sync="opportunity.opportunityOrigin"
                @update:input="(newValue) => {
                  opportunity.opportunityOrigin = newValue
                }">
              </CAutocomplete>
            </CCol>
            <CCol sm="6">
              <CAutocomplete
                required
                label="Grupo Oportunidad: "
                :options="opportunityGroups"
                :value.sync="opportunity.opportunityGroup"
                @update:input="(newValue) => {
                  opportunity.opportunityGroup = newValue
                }">
              </CAutocomplete>
            </CCol>
            <CCol sm="6">
              <CAutocomplete
                required
                label="Fase Venta: "
                :options="sellPhases"
                :value.sync="opportunity.sellPhase"
                @update:input="(newValue) => {
                  opportunity.sellPhase = newValue
                }">
              </CAutocomplete>
            </CCol>
            <CCol col="6" sm="6">
              <label class="text-muted font-weight-bold">Marcas:</label>
              <vueTagsInput
                v-model="tag"
                placeholder="Marca"
                :max-tags="5"
                :tags="brands"
                :add-only-from-autocomplete="true"
                :autocomplete-items="filteredBrands"
                @tags-changed="(newTags) => { brands = newTags; }" 
              />
            </CCol>
            <CCol sm="12">
              <CInput
                label="Descipción: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="opportunity.description"
                :isValid="Boolean(opportunity.description)"
              />
            </CCol>
            <CCol sm="12">
              <CTextarea
                label="Observaciones: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="opportunity.observations"
                :isValid="Boolean(opportunity.observations)"
              />
            </CCol>
            <CCol sm="6">
              <div class="form-group" role="group">
                <label for="expectedBusinessValue" class="text-muted font-weight-bold">Valor Negocio Previsto:</label>
                <input type="text"
                  id="expectedBusinessValue"
                  class="form-control" 
                  v-mask="currencyMask"
                  v-model="expectedBusinessValue"
                  :class="opportunity.expectedBusinessValue > 0 ? 'is-valid' : 'is-invalid'"
                  @change="(value) => expectedBusinessValueChange(value)"
                />
              </div>
            </CCol>
            <CCol sm="4">
              <CSelect
                label="Prioridad: "
                addLabelClasses="text-muted font-weight-bold"
                :value.sync="opportunity.priority"
                :options="[
                  { value: 'M', label: 'Muy Importante' },
                  { value: 'I', label: 'Importante' },
                  { value: 'B', label: 'Baja' }                                
                ]"
              />
            </CCol>
            <CCol sm="12">
              <CAutocomplete
                required
                label="Personal"
                :options="persons"
                :value.sync="opportunity.employee"
                @update:input="(newValue) => {
                  opportunity.employee = newValue
                }">
              </CAutocomplete>
            </CCol>
          </CRow>
        </CForm>
      </CCardBody>
      <CCardFooter class="d-flex justify-content-center">
        <CButton
          color="success"
          class="mr-2"
          :class="isValidForm ? '' : 'disabled'"
          :disabled="!isValidForm"
          @click="saveOpportunity()">
          <CIcon name="cil-check-circle"/>
          <span class="align-middle ml-2">Guardar</span>
        </CButton>
        <CButton
          color="danger"
          variant="outline"
          :to="rootPath">
          <CIcon name="cil-x-circle"/>
          <span class="align-middle ml-2">Cancelar</span>
        </CButton>
      </CCardFooter>

      <CElementCover v-show="loading"/>
    </CCard>
  </CContainer>
</template>
<script>
  import vueTagsInput from "@johmun/vue-tags-input";
  import createNumberMask from "text-mask-addons/dist/createNumberMask"

  import CAutocomplete from "@/components/containers/CAutocomplete";
  import { errorMessage } from "@/general";
  import { 
    guardaOportunidad,
    dataListOrigenesOportunidades,
    dataListGruposOportunidades,
    dataListFasesVentas,
    dataListPersonal,
    dataListCampania,
    searchDirectorio,
    dataListDependencias
  } from "@/api"
  import { dataListMarcas } from "@/apiDataList";

  const currencyMask = createNumberMask({
    prefix: "$",
    integerLimit: 12,
    allowDecimal: true,
    decimalSymbol: ",",
    thousandsSeparatorSymbol: ".",
    includeThousandsSeparator: true,
    allowNegative: false,
  })

  export default {
    data() {
      return {
        loading: false,
        rootPath: "",
        isCreate: false,
        idOportunity: "",
        opportunity: {
          employee: "",
          directory: "",
          dependency: "",
          campaign: "",
          opportunityOrigin: "",
          opportunityGroup: "",
          sellPhase: "",
          brands: "",
          description: "",
          observations: "",
          expectedBusinessValue: 0,
          priority: "I"
        },
        currencyMask,
        directories: [],
        dependencies: [],
        campaigns: [],
        opportunityOrigins: [],
        opportunityGroups: [],
        sellPhases: [],
        persons: [],
        tag: "",
        brands: [],
        listBrands: [],
        expectedBusinessValue: 0
      }
    },
    components: {
      vueTagsInput,
      CAutocomplete
    },
    methods: {
      async saveOpportunity() {
        this.loading = true;

        try {
          await guardaOportunidad(
            this,
            this.opportunity.employee,
            this.opportunity.directory,
            this.opportunity.dependency,
            this.opportunity.campaign,
            this.opportunity.opportunityOrigin,
            this.opportunity.opportunityGroup,
            this.opportunity.sellPhase,
            this.opportunity.description,
            this.opportunity.observations,
            this.opportunity.expectedBusinessValue,
            this.opportunity.priority
          )
          this.$router.push({ path: this.rootPath });
        } catch (error) {
          this.$store.commit("setAlert", {
            color: "danger",
            message: errorMessage(error),
            show: 5
          });
        } finally {
          this.loading = false
        }
      },
      async getDependencies() {
        try {
          setTimeout(
            async () => {
              const response = await dataListDependencias(this, this.opportunity.directory)
              this.dependencies = response.map(item => { return { value: item.id_Dependencia, label: item.dependencia}})
            },
            100
          )
        } catch (error) {
          console.log(error)
        }
      },
      async getCampaigns() {
        try {
          const response = await dataListCampania(this)
          this.campaigns = response.map(item => { return { value: item.id_Campania, label: item.nombre_Campania}})            
        } catch (error) {
          console.log(error)
        }
      },
      async getOpportunityOrigins() {
          try {
          const response = await dataListOrigenesOportunidades(this)
          this.opportunityOrigins = response.map(item => { return { value: item.id_OrigenOportunidad, label: item.origen_Oportunidad}})
          } catch (error) {
          console.log(error)
          }
      },
      async getOpportunityGroups() {
          try {
          const response = await dataListGruposOportunidades(this)
          this.opportunityGroups = response.map(item => { return { value: item.id_GrupoOportunidad, label: item.grupo_Oportunidad}})
          } catch (error) {
          console.log(error)
          }
      },
      async getSellPhases() {
          try {
          const response = await dataListFasesVentas(this)
          this.sellPhases = response.map(item => { return { value: item.id_FaseVenta, label: item.fase_Venta } })
          } catch (error) {
          console.log(error)
          }
      },
      async getListBrands() {
        try {
          const response = await dataListMarcas(this);
          this.listBrands = response.map(item => { return { text: item.marca } });
        } catch (error) {
          console.log(error);
        }
      },
      async getListPersonal() {
        try {
          const response = await dataListPersonal(this)
          this.persons = response.map(item => { return { value: item.id_Personal, label: `${item.nombre_Empleado} - ${item.identificacion}`}})
        } catch (error) {
          console.log(error)
        }
      },
      async getDirectoryData(value){
        if (value.length > 2) {
          try {
            const response = await searchDirectorio(this, value)
            this.directories = response.map(item => {
              return {
                value: item.id_Directorio,
                label: `${item.empresa} - ${item.identificacion}`
              }
            })
          } catch (error) {
            this.$store.commit(
              "setAlert",
              {
                color: "danger",
                message: "Error al cargar datos",
                show: 5
              }
            )
          }
        }
      
      },
      expectedBusinessValueChange(value) {
        setTimeout(
          () => {
            this.opportunity.expectedBusinessValue = value.target.value.replace("$","").replaceAll(".","").replaceAll(",",".")          
          },
          100
        )
      }
    },
    computed: {
      isValidForm() {
        return Object.keys(this.opportunity).every(key => {
          if (key === "dependency" || key === "campaign" || key === "brands") {
            return true
          }

          return this.opportunity[key].length > 0
        })
      },
      filteredBrands() {
        return this.listBrands.filter(i => {
          return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1;
        });
      }
    },
    mounted() {
      this.rootPath = this.$router.currentRoute.fullPath;
      this.isCreate = this.rootPath.includes("agregar");
      
      if (this.isCreate) {
        this.rootPath = this.rootPath.replace("/agregar", "");
      } else {
        this.idOportunity = this.$router.currentRoute.params.id;
        this.rootPath = this.rootPath.replace(`/editar/${this.idOportunity}`, "");

        // this.getProspectData();
      }

      this.getCampaigns();
      this.getOpportunityOrigins();
      this.getOpportunityGroups();
      this.getSellPhases();
      this.getListPersonal();
      this.getListBrands();
    }
  }
</script>
